import React from 'react';

export const LogoPaymentSuscription = (props) => {
  return (
    <img
      {...props}
      src="https://dk0k1i3js6c49.cloudfront.net/panel/suscripciones/cards.png"
    />
  );
};
